import { AgricultureMapConstants, LAYER_TYPES, LOCATIONS_ZOOM_RANGE } from "src/app/main/constants/dims-map-constants";
import * as L from 'leaflet';

export const LOCATION_HIE: any = ['COUNTRY', 'STATE', 'DISTRICT', 'BLOCK', 'WARD']
export const DANA_LAYER_LIST: any = {
    [AgricultureMapConstants.LOCATIONS.INDIA]: {
        'KolkataOuter Boundaries': {
            source: 'INDIA',
            displayName: 'KolkataOuter Boundaries',
            name: 'KolkataOuter Boundaries',
            visible: true,
            view: AgricultureMapConstants.VIEWS.ADMIN,
            dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
            layerptions_show_on_selector: false,
            layeroptions_name: 'HEATWAVE:Kolkata_outerboundary',
            layer_name: 'KolkataOuter Boundaries',
            layeroptions_pane: 'depth',
            layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.VILLAGE].MIN,
            layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.VILLAGE].MAX,
            group: 'boundaries',
            group_type: 'radio-deselect',
            layerServiceType: LAYER_TYPES.GEOJSON_LAYER,
            type: LAYER_TYPES.GEOJSON_LAYER,
            // cql_filter_value: 'UUID',
            cql_filter: null,
            layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
            onEachFeature: 'handleAdminPolygons',
            environment_server_url: 'COMMON_GEOSERVER_URL',
            layeroptions_protocol: 'WFS'
        },
        'District Boundary': {
            source: 'INDIA',
            displayName: 'District',
            name: 'District Boundary',
            visible: true,
            // hasLegend: true,
            view: AgricultureMapConstants.VIEWS.ADMIN,
            dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
            layerptions_show_on_selector: false,
            layeroptions_name: 'HEATWAVE:ALL_INDIA_DISTRICT',
            layer_name: 'District Boundary',
            layeroptions_pane: 'district',
            // layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MIN,
            layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MIN - 1,
            layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MAX,
            group: 'boundaries',
            group_type: 'radio-deselect',
            layerServiceType: LAYER_TYPES.VECTOR_LAYER,
            type: LAYER_TYPES.VECTOR_LAYER,
            cql_filter_value: null,
            cql_filter: null,
            layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
            environment_server_url: 'COMMON_GEOSERVER_URL',
            // layeroptions_styles: 'HEATWAVE:INDIA_DISTRICT_NAMES',
            crs: 'EPSG4326',
            hasLables: true,
            applycql_filter: true,
            legendName: 'HEATWAVE_LEGEND',
            layeroptions_protocol: 'WFS'
        },
        'Block Boundary': {
            source: 'INDIA',
            displayName: 'Block',
            name: 'Block Boundary',
            visible: true,
            view: AgricultureMapConstants.VIEWS.ADMIN,
            dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
            layerptions_show_on_selector: false,
            layeroptions_name: 'HEATWAVE:ALL_INDIA_BLOCKS',
            layer_name: 'Block Boundary',
            layeroptions_pane: 'state',
            // layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MIN,
            layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MIN - 2,
            layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MAX,
            group: 'boundaries',
            group_type: 'radio-deselect',
            layerServiceType: LAYER_TYPES.VECTOR_LAYER,
            type: LAYER_TYPES.VECTOR_LAYER,
            cql_filter_value: null,
            cql_filter: null,
            layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
            environment_server_url: 'COMMON_GEOSERVER_URL',
            // layeroptions_styles: 'HEATWAVE:ALL_INDIA_BLOCK_NAMES',
            crs: 'EPSG4326',
            hasLables: true,
            applycql_filter: true,
            legendName: 'HEATWAVE_LEGEND',
            layeroptions_protocol: 'WFS'
        },
        'Ward Boundary': {
            source: 'INDIA',
            displayName: 'Ward Boundary',
            name: 'Ward Boundary',
            visible: true,
            hasLegend: true,
            view: AgricultureMapConstants.VIEWS.ADMIN,
            dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
            layerptions_show_on_selector: false,
            layeroptions_name: 'HEATWAVE:KLKT_WARD_BOUNDARY',
            layer_name: 'Ward Boundary',
            layeroptions_pane: 'max',
            layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.PANCHAYAT].MIN,
            layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.PANCHAYAT].MAX,
            group: 'Administrative Boundaries',
            group_type: 'radio-deselect',
            layerServiceType: LAYER_TYPES.WMS_LAYER,
            type: LAYER_TYPES.WMS_LAYER,
            cql_filter_value: null,
            cql_filter: null,
            layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
            environment_server_url: 'COMMON_GEOSERVER_URL',
            layeroptions_styles: 'HEATWAVE:WARD_BOUNDARY',
            legendName: 'RADAR_LEGEND',
            crs: 'EPSG4326',
            applycql_filter: true
        },
        'Ward Boundary Labels': {
            source: 'INDIA',
            displayName: 'Ward Boundary Labels',
            name: 'Ward Boundary Labels',
            visible: true,
            hasLegend: true,
            view: AgricultureMapConstants.VIEWS.ADMIN,
            dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
            layerptions_show_on_selector: false,
            layeroptions_name: 'HEATWAVE:KLKT_WARD_BOUNDARY',
            layer_name: 'Ward Boundary Labels',
            layeroptions_pane: 'max',
            layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.PANCHAYAT].MIN,
            layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.PANCHAYAT].MAX,
            group: 'Administrative Boundaries',
            group_type: 'radio-deselect',
            layerServiceType: LAYER_TYPES.WMS_LAYER,
            type: LAYER_TYPES.WMS_LAYER,
            cql_filter_value: null,
            cql_filter: null,
            layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
            environment_server_url: 'COMMON_GEOSERVER_URL',
            layeroptions_styles: 'HEATWAVE:WARD_LABELS_KLKT',
            legendName: 'RADAR_LEGEND',
            crs: 'EPSG4326',
            applycql_filter: true
        },
    }
}

export const DANA_LEGEND_LIST: any = {
    [AgricultureMapConstants.LOCATIONS.INDIA]: {
        IMD_RADAR_MODEL_INPUT_NOWCAST: {
            RADAR_LEGEND: {
                colorValues: [
                    {
                        backgroundColor: '#e6eeff',
                        textColor: '#000000',
                        text: '0'
                    },
                    {
                        backgroundColor: '#e6eeff',
                        textColor: '#000000',
                        text: '5'
                    },
                    {
                        backgroundColor: '#80aaff',
                        textColor: '#000000',
                        text: '10'
                    },
                    {
                        backgroundColor: '#3377ff',
                        textColor: '#000000',
                        text: '15'
                    },
                    {
                        backgroundColor: '#3377ff',
                        textColor: '#000000',
                        text: '20'
                    },
                    {
                        backgroundColor: '#003cb3',
                        textColor: '#ffffff',
                        text: '25'
                    },
                    {
                        backgroundColor: '#002266',
                        textColor: '#ffffff',
                        text: '30'
                    },
                    {
                        backgroundColor: '#ff80b3',
                        textColor: '#000000',
                        text: '35'
                    },
                    {
                        backgroundColor: '#ff80b3',
                        textColor: '#000000',
                        text: '40'
                    },
                    {
                        backgroundColor: '#ff0066',
                        textColor: '#000000',
                        text: '45'
                    },
                    {
                        backgroundColor: '#ff0066',
                        textColor: '#000000',
                        text: '50'
                    },
                    {
                        backgroundColor: '#cc0000',
                        textColor: '#000000',
                        text: '55'
                    },
                    {
                        backgroundColor: '#cc0000',
                        textColor: '#000000',
                        text: '60'
                    },
                    {
                        backgroundColor: '#660000',
                        textColor: '#ffffff',
                        text: '65'
                    },
                    {
                        backgroundColor: '#ffcccc',
                        textColor: '#000000',
                        text: '>70'
                    },
                    // {
                    //   backgroundColor: '#ffcccc',
                    //   color: '#000000',
                    //   text: '75'
                    // }
                ],
                Units: 'dbZ'
            }
        },
        CTT_MODEL_INPUT_NOWCAST: {
            CTT_LEGEND: {
                colorValues: [
                    {
                        backgroundColor: '#ffcccc',
                        textColor: '#000000',
                        text: '-93'
                    },
                    {
                        backgroundColor: '#e0b3b3',
                        textColor: '#000000',
                        text: '-85.5'
                    },
                    {
                        backgroundColor: '#9e1001',
                        textColor: '#ffffff',
                        text: '-78'
                    },
                    {
                        backgroundColor: '#b41b01',
                        textColor: '#ffffff',
                        text: '-70.5'
                    },
                    {
                        backgroundColor: '#ff0066',
                        textColor: '#000000',
                        text: '-63'
                    },
                    {
                        backgroundColor: '#ff0066',
                        textColor: '#000000',
                        text: '-55.5'
                    },
                    {
                        backgroundColor: '#ff80b3',
                        textColor: '#000000',
                        text: '-48'
                    },
                    {
                        backgroundColor: '#ff80b3',
                        textColor: '#000000',
                        text: '-40.5'
                    },
                    {
                        backgroundColor: '#002266',
                        textColor: '#ffffff',
                        text: '-33'
                    },
                    {
                        backgroundColor: '#003cb3',
                        textColor: '#ffffff',
                        text: '-20'
                    },
                    {
                        backgroundColor: '#3377ff',
                        textColor: '#000000',
                        text: '-10'
                    },
                    {
                        backgroundColor: '#80aaff',
                        textColor: '#000000',
                        text: '00.0'
                    },
                    {
                        backgroundColor: '#b3cce6',
                        textColor: '#000000',
                        text: '10.0'
                    },
                    {
                        backgroundColor: '#e6eeff',
                        textColor: '#000000',
                        text: '20.0'
                    },
                    {
                        backgroundColor: '#b3cce6',
                        textColor: '#000000',
                        text: '30.0'
                    },
                    {
                        backgroundColor: '#80aaff',
                        textColor: '#000000',
                        text: '>40.0'
                    },
                    // {
                    //   backgroundColor: '#80aaff',
                    //   color: '#000000',
                    //   text: '50.0'
                    // },
                ],
                Units: '(°C)'
            }
        },
        EUMETSAT_MODEL_INPUT_NOWCAST: {
            EUMETSAT_LEGEND: {
                colorValues: [
                    {
                        backgroundColor: '#e6eeff',
                        color: '#000000',
                        text: '0.5'
                    },
                    {
                        backgroundColor: '#80aaff',
                        color: '#000000',
                        text: '2.5'
                    },
                    {
                        backgroundColor: '#3377ff',
                        color: '#000000',
                        text: '5'
                    },
                    {
                        backgroundColor: '#003cb3',
                        color: '#000000',
                        text: '10'
                    },
                    {
                        backgroundColor: '#002266',
                        color: '#000000',
                        text: '20'
                    },
                    {
                        backgroundColor: '#ff80b3',
                        color: '#000000',
                        text: '30'
                    },
                    {
                        backgroundColor: '#ff0066',
                        color: '#000000',
                        text: '40'
                    },
                    {
                        backgroundColor: '#cc0000',
                        color: '#000000',
                        text: '50'
                    },
                    {
                        backgroundColor: '#660000',
                        color: '#000000',
                        text: '75'
                    },
                    {
                        backgroundColor: '#ffcccc',
                        color: '#000000',
                        text: '>100'
                    },
                    // {
                    //   backgroundColor: '#ffcccc',
                    //   color: '#000000',
                    //   text: '1000'
                    // }
                ],
                Units: 'mm/hr'
            }
        },
        MODEL_INPUT_NOWCAST: {
            RAINFALL_LEGEND: {
                colorValues: [
                    {
                        backgroundColor: '#ffcccc',
                        textColor: '#000000',
                        text: '>100'
                    },
                    {
                        backgroundColor: '#660000',
                        textColor: '#000000',
                        text: '75-100'
                    },
                    {
                        backgroundColor: '#cc0000',
                        textColor: '#000000',
                        text: '50-75'
                    },
                    {
                        backgroundColor: '#ff0066',
                        textColor: '#000000',
                        text: '40-50'
                    },
                    {
                        backgroundColor: '#ff80b3',
                        textColor: '#000000',
                        text: '30-40'
                    },
                    {
                        backgroundColor: '#002266',
                        textColor: '#000000',
                        text: '20-30'
                    },
                    {
                        backgroundColor: '#003cb3',
                        textColor: '#000000',
                        text: '10-20'
                    },
                    {
                        backgroundColor: '#3377ff',
                        textColor: '#000000',
                        text: '5-10'
                    },
                    {
                        backgroundColor: '#80aaff',
                        textColor: '#000000',
                        text: '2.5-5'
                    },
                    {
                        backgroundColor: '#e6eeff',
                        textColor: '#000000',
                        text: '0.5-2.5'
                    },
                    {
                        backgroundColor: 'transparent',
                        textColor: '#000000',
                        text: '0-0.5'
                    }
                ],
                Units: 'mm/hr'
            }
        },
        IMD_RADAR_NOWCAST: {
            RADAR_LEGEND: {
                "Units": "mm/hr ",
                "colorValues": [
                    {
                        backgroundColor: 'transparent',
                        textColor: '#000000',
                        text: '0-0.5 (no rainfall)'
                    },
                    {
                        backgroundColor: '#e6eeff',
                        textColor: '#000000',
                        text: '0.5-2.5'
                    },
                    {
                        backgroundColor: '#80aaff',
                        textColor: '#000000',
                        text: '2.5-5'
                    },
                    {
                        backgroundColor: '#3377ff',
                        textColor: '#000000',
                        text: '5-10'
                    },
                    {
                        backgroundColor: '#003cb3',
                        textColor: '#000000',
                        text: '10-20'
                    },
                    {
                        backgroundColor: '#002266',
                        textColor: '#ffffff',
                        text: '20-30'
                    },
                    {
                        backgroundColor: '#ff80b3',
                        textColor: '#000000',
                        text: '30-40'
                    },
                    {
                        backgroundColor: '#ff0066',
                        textColor: '#000000',
                        text: '40-50'
                    },
                    {
                        backgroundColor: '#cc0000',
                        textColor: '#000000',
                        text: '50-75'
                    },
                    {
                        backgroundColor: '#660000',
                        textColor: '#ffffff',
                        text: '75-100'
                    },
                ]
            }
        },
    }
}

export const DanaCycloneMapConstants: any = {
    HeatMapOptions: {
        type: 'Time',
        time: '24',
        clip: true,
        view: 'Admin',
        serviceType: 'HeatMap'
    }
}

export const SOURCE_VS_LEGEND: any = {
    IMD_RADAR_MODEL_INPUT_NOWCAST: 'RADAR_LEGEND',
    CTT_MODEL_INPUT_NOWCAST: 'CTT_LEGEND',
    EUMETSAT_MODEL_INPUT_NOWCAST: 'EUMETSAT_LEGEND',
    MODEL_INPUT_NOWCAST: 'RAINFALL_LEGEND',
}

export const DATE_VS_TIMESTAMPLIST: any = {
    '19_10_2024': [
        1729360200000,
        1729359600000,
        1729359000000,
        1729358400000,
        1729357800000,
        1729357200000,
        1729356600000,
        1729355400000,
        1729354800000,
        1729354200000,
        1729353600000,
        1729352400000,
        1729351800000,
        1729351200000,
        1729350600000,
        1729350000000,
        1729349400000,
        1729348200000,
        1729347600000,
        1729347000000,
        1729346400000,
        1729345800000,
        1729345200000,
        1729344000000,
        1729343400000,
        1729342800000,
        1729341600000,
        1729341000000,
        1729340400000,
        1729339800000,
        1729339200000,
        1729338600000,
        1729338000000,
        1729337400000,
        1729336800000,
        1729336200000,
        1729335600000,
        1729335000000,
        1729334400000,
        1729333800000,
        1729333200000,
        1729332600000,
        1729332000000,
        1729331400000,
        1729330800000,
        1729330200000,
        1729329600000,
        1729329000000,
        1729328400000,
        1729327800000,
        1729327200000,
        1729326600000,
        1729326000000,
        1729325400000,
        1729324800000,
        1729324200000,
        1729323600000,
        1729323000000,
        1729321800000,
        1729321200000,
        1729320600000,
        1729320000000,
        1729318800000,
        1729318200000,
        1729317600000,
        1729317000000,
        1729316400000,
        1729315800000,
        1729315200000,
        1729314600000,
        1729314000000,
        1729313400000,
        1729312800000,
        1729312200000,
        1729311600000,
        1729311000000,
        1729310400000,
        1729309200000,
        1729308600000,
        1729308000000,
        1729307400000,
        1729306800000,
        1729306200000,
        1729305600000,
        1729305000000,
        1729304400000,
        1729303800000,
        1729303200000,
        1729302000000,
        1729301400000,
        1729300800000,
        1729300200000,
        1729299000000,
        1729298400000,
        1729297800000,
        1729297200000,
        1729296600000,
        1729296000000,
        1729295400000,
        1729294800000,
        1729294200000,
        1729293600000,
        1729293000000,
        1729292400000,
        1729291800000,
        1729291200000,
        1729290600000,
        1729290000000,
        1729289400000,
        1729288200000,
        1729287600000,
        1729287000000,
        1729286400000,
        1729285800000,
        1729285200000,
        1729284600000,
        1729284000000,
        1729283400000,
        1729282800000,
        1729282200000,
        1729281600000,
        1729280400000,
        1729279800000,
        1729279200000,
        1729278600000,
        1729278000000,
        1729277400000,
        1729276800000,
        1729276200000,
        1729275600000,
    ],
    '20_10_2024': [
        1729401600000,
        1729401000000,
        1729400400000,
        1729399200000,
        1729398600000,
        1729398000000,
        1729397400000,
        1729396800000,
        1729396200000,
        1729395600000,
        1729395000000,
        1729393800000,
        1729393200000,
        1729392600000,
        1729392000000,
        1729390800000,
        1729390200000,
        1729389600000,
        1729389000000,
        1729387800000,
        1729387200000,
        1729386600000,
        1729386000000,
        1729385400000,
        1729384200000,
        1729383600000,
        1729383000000,
        1729382400000,
        1729381200000,
        1729380600000,
        1729380000000,
        1729379400000,
        1729378200000,
        1729377600000,
        1729377000000,
        1729375200000,
        1729374600000,
        1729374000000,
        1729373400000,
        1729372800000,
        1729371600000,
        1729371000000,
        1729370400000,
        1729369800000,
        1729368600000,
        1729368000000,
        1729367400000,
        1729366800000,
        1729365600000,
        1729365000000,
        1729364400000,
        1729363200000,
        1729362600000,
        1729362000000,
    ],
    '21_10_2024': [
        1729534200000,
        1729533600000,
        1729533000000,
        1729532400000,
        1729531800000,
        1729531200000,
        1729530600000,
        1729530000000,
        1729529400000,
        1729528800000,
        1729528200000,
        1729527600000,
        1729527000000,
        1729526400000,
        1729525800000,
        1729525200000,
        1729524600000,
        1729524000000,
        1729523400000,
        1729522800000,
        1729522200000,
        1729521600000,
        1729521000000,
        1729520400000,
        1729519800000,
        1729519200000,
        1729518600000,
        1729518000000,
        1729517400000,
        1729516800000,
        1729516200000,
        1729515600000,
        1729515000000,
        1729514400000,
        1729513800000,
        1729513200000,
        1729512600000,
        1729512000000,
        1729511400000,
        1729510800000,
        1729510200000,
        1729509600000,
        1729509000000,
        1729508400000,
        1729507800000,
        1729507200000,
        1729506600000,
        1729506000000,
        1729505400000,
        1729504200000,
        1729503600000,
        1729503000000,
        1729502400000,
        1729501800000,
        1729501200000,
        1729500600000,
        1729500000000,
        1729499400000,
        1729498800000,
        1729498200000,
        1729497600000,
        1729497000000,
        1729496400000,
        1729495800000,
        1729495200000,
        1729494600000,
        1729494000000,
        1729492800000,
        1729492200000,
        1729491600000,
    ]
}

export const KOLKATAEVENT_2025_TIMESTAMPLIST: any = [
    1751913000000,
    1751912400000,
    1751911800000,
    1751911200000,
    1751910600000,
    1751910000000,
    1751909400000,
    1751891400000,
    1751890800000,
    1751890200000,
    1751889600000,
    1751877600000,
    1751877000000,
    1751876400000,
    1751875800000,
    1751875200000,
    1751874600000,
    1751874000000,
    1751873400000,
    1751872800000,
    1751872200000,
    1751871600000,
    1751871000000,
    1751870400000,
    1751869800000,
    1751869200000,
    1751868600000,
    1751868000000,
    1751867400000,
    1751866800000,
    1751866200000,
    1751865600000,
    1751865000000,
    1751864400000,
    1751863800000,
    1751863200000,
    1751862600000,
    1751862000000,
    1751861400000,
    1751860800000,
    1751860200000,
    1751859600000,
    1751859000000,
    1751858400000,
    1751857800000,
    1751857200000,
    1751856600000,
    1751856000000,
    1751855400000,
    1751854800000,
    1751854200000,
    1751853600000,
    1751853000000,
    1751852400000,
    1751851800000,
    1751851200000,
    1751850600000,
    1751850000000,
    1751849400000,
    1751848800000,
    1751848200000,
    1751847600000,
    1751847000000,
    1751846400000,
    1751845800000,
    1751845200000,
    1751844600000,
    1751844000000,
    1751843400000,
    1751842800000,
    1751842200000,
    1751841600000,
    1751841000000,
    1751840400000,
    1751839800000,
    1751839200000,
    1751838600000,
    1751838000000,
    1751837400000,
    1751836800000,
    1751836200000,
    1751835600000,
    1751835000000,
    1751834400000,
    1751833800000,
    1751833200000,
    1751832600000,
    1751832000000,
    1751831400000,
    1751830800000,
    1751830200000,
    1751829600000,
    1751829000000,
    1751828400000,
    1751827800000,
    1751827200000,
    1751826600000,
    1751826000000,
    1751825400000,
    1751824800000,
    1751824200000,
    1751823600000,
    1751823000000,
    1751822400000,
    1751821800000,
    1751821200000,
    1751820600000,
    1751820000000,
    1751819400000,
    1751818800000,
    1751818200000,
    1751817600000,
    1751817000000,
    1751816400000,
    1751815800000,
    1751815200000,
    1751814600000,
    1751814000000,
    1751813400000,
    1751812800000,
    1751812200000,
    1751811600000,
    1751811000000,
    1751810400000,
    1751809800000,
    1751809200000,
    1751808600000,
    1751808000000,
    1751807400000,
    1751806800000,
    1751806200000,
    1751805600000,
    1751805000000,
    1751804400000,
    1751803800000,
    1751803200000,
    1751802600000,
    1751802000000,
    1751801400000,
    1751800800000,
    1751800200000,
    1751799600000,
    1751799000000,
    1751798400000,
    1751797800000,
    1751797200000,
    1751796600000,
    1751796000000,
    1751795400000,
    1751794800000,
    1751794200000,
    1751793600000,
    1751793000000,
    1751792400000,
    1751791800000,
    1751783400000,
    1751782800000,
    1751782200000,
    1751781600000,
    1751781000000,
    1751780400000,
    1751779800000,
    1751779200000,
    1751778600000,
    1751778000000,
    1751777400000,
    1751776800000,
    1751776200000,
    1751775600000,
    1751775000000,
    1751774400000,
    1751773800000,
    1751773200000,
    1751772600000,
    1751772000000,
    1751771400000,
    1751770800000,
    1751770200000,
    1751769600000,
    1751769000000,
    1751768400000,
    1751767800000,
    1751767200000,
    1751766600000,
    1751766000000,
    1751765400000,
    1751764800000,
    1751764200000,
    1751763600000,
    1751763000000,
    1751762400000,
    1751761800000,
    1751761200000,
    1751760600000,
    1751760000000,
    1751759400000,
    1751758800000,
    1751758200000,
    1751757600000,
    1751757000000,
    1751756400000,
    1751755800000,
    1751755200000,
    1751754600000,
    1751754000000,
    1751753400000,
    1751752800000,
    1751752200000,
    1751751600000,
    1751751000000,
    1751750400000,
    1751749800000,
    1751749200000,
    1751748600000,
    1751748000000,
    1751747400000,
    1751746800000,
    1751746200000,
    1751745600000,
    1751745000000,
    1751744400000,
    1751743800000,
    1751743200000,
    1751742600000,
    1751742000000,
    1751741400000,
    1751740800000
]